module.exports = __webpack_public_path__ + "static/media/18.Music Notes.fe1cdacf.gif";